import { render, staticRenderFns } from "./TouchpointStatistics.vue?vue&type=template&id=c3c031ce&scoped=true&"
import script from "./TouchpointStatistics.vue?vue&type=script&lang=js&"
export * from "./TouchpointStatistics.vue?vue&type=script&lang=js&"
import style0 from "./TouchpointStatistics.vue?vue&type=style&index=0&id=c3c031ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c031ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3c031ce')) {
      api.createRecord('c3c031ce', component.options)
    } else {
      api.reload('c3c031ce', component.options)
    }
    module.hot.accept("./TouchpointStatistics.vue?vue&type=template&id=c3c031ce&scoped=true&", function () {
      api.rerender('c3c031ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/TouchpointOverview/Statistics/TouchpointStatistics.vue"
export default component.exports